import { render, staticRenderFns } from "./GroupAddUser.vue?vue&type=template&id=3991c3e4&scoped=true&"
import script from "./GroupAddUser.vue?vue&type=script&lang=ts&"
export * from "./GroupAddUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3991c3e4",
  null
  
)

export default component.exports